import {Aurelia, LogManager} from 'aurelia-framework';
import {bootstrap} from 'aurelia-bootstrapper';
import {PLATFORM} from "aurelia-pal";
import config from "./config";

bootstrap(async (aurelia: Aurelia) => {

    let root = document.getElementById('gift-card-client');
    if (!root) {
        console.error("Could not find root-element 'gift-card-client' ");
    }

    aurelia.use
        .standardConfiguration()
        .developmentLogging()
        .eventAggregator()

    if (config.debugLogging) {
        LogManager.setLevel(LogManager.logLevel.debug)
    } else {
        LogManager.setLevel(LogManager.logLevel.error)
    }

    await aurelia.start();
    aurelia.setRoot(PLATFORM.moduleName('app'), root);
});